import { MdListAlt } from "react-icons/md";
import subOrdersService from "services/admin/sub-orders.service";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const OrdersCount = ({ month }) => {
  const q = useDashboardQuery(["orders-count", month], async () => (await subOrdersService.count({ month })).data);

  return (
    <KpiCard
      icon={MdListAlt}
      accent="amber"
      label="Заказы"
      hint="Заказы, созданные за выбранный период"
      to="/admin/sub-orders/list"
      value={formatNumber(q.data)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default OrdersCount;
